import axios from "axios";
import Constants from "../../../components.constants.js";


// function createTagsMapper(tagsList) {
//     let tempTagInfo = {}
//     for (let tag of tagsList) {
//         tempTagInfo[tag._id] = { _id: tag._id, name: tag.name }
//     }
//     return tempTagInfo
// }


export default {

    async getAllLabelsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.labelsConfigUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllLabelsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getLabelsInfoFromServer(context, payload = {}) {
        //payload : {params:{tagId:"3422344231"}}

        try {
            let labelId = payload.params.labelId
            delete payload.params.labelId
            let resp = await axios.get(`${Constants.labelsConfigUrl}/${labelId}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                // if (!(labelId in context.state.label)) {
                //     context.commit("setTagsinfo", resp.data.label)
                // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getLabelsInfoFromServer][Store][Error occured while getting Tag info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getLabelsAutocomplete(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.labelsConfigUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getLabelsAutocomplete][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async addNewLabel(context, payload = {}) {
        //payload : FUSION Users JSON schema

        try {
            let resp = await axios.post(Constants.labelsConfigUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[addNewLabel][Store][Tag add resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[addNewLabel][Store][Error occured while adding tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async updateExistingLabel(context, payload = {}) {
        //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}
        try {
            let resp = await axios.put(`${Constants.labelsConfigUrl}/${payload.params._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateExistingLabel][Store][Tag update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateExistingLabel][Store][Error occured while updating Tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async deleteExistingLabel(context, payload = {}) {
        //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}

        try {
            let resp = await axios.delete(`${Constants.labelsConfigUrl}/${payload._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[deleteExistingLabel][Store][Tag Delete resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[deleteExistingLabel][Store][Error occured while deleting Tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },
};